import { useSessionStore } from "@auth/sessionStore";
import { useClinicUsers } from "@users/userQueries";
import { relativeTime } from "@utils/relative-time";
import type { View } from "@views/viewsClient";
import { useViewSignoffs } from "@views/viewsQueries";

/** A signed view's sign-off audit trail (BE-2034), shown in the view detail. */
export const ViewSignoffs = ({ view }: { view: View }) => {
  const sessionKey = useSessionStore((s) => s.user?.userUuid ?? "");
  const { data: users } = useClinicUsers(sessionKey);
  const { data: signoffs = [] } = useViewSignoffs(view.id);

  if (signoffs.length === 0) return null;

  const nameFor = (userId: string | null) =>
    users?.find((u) => u.id === userId)?.displayName ?? "Unknown user";

  return (
    <section className="rounded-paper border border-rule p-3">
      <h3 className="text-annotation-caps text-annotation">Sign-off history</h3>
      <ul className="mt-2 flex flex-col gap-1.5">
        {signoffs.map((e) => (
          <li
            key={e.id}
            className="flex items-baseline justify-between gap-3 text-sm text-annotation"
          >
            <span className="min-w-0">
              <span className="font-medium text-ink">{nameFor(e.userId)}</span>{" "}
              {e.action}
              {e.reason && <> — {e.reason}</>}
            </span>
            <span className="shrink-0 text-xs">
              {relativeTime(new Date(e.createdAt).getTime())}
            </span>
          </li>
        ))}
      </ul>
    </section>
  );
};
